// extracted by mini-css-extract-plugin
module.exports = {"header-container":"ViewsPanel_header-container__IPGw0","views-container":"ViewsPanel_views-container__n32MK"};